import React, { Component } from 'react';
import './Row.css';

export default class Row extends Component {
	render() {
		let clickable = !!this.props.onClick ? ' clickable ' : '';
    const otherProps = {}

    if(clickable) {
      otherProps.tabIndex = "0"
    }
		return (
			<div  {...otherProps} role="row" style={this.props.style || {}} onClick={this.props.onClick} className={'g-row ' + (this.props.className || '') + clickable}>
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/row/Row.jsx